window.CursorParallax = require('./main');


// WEBPACK FOOTER //
// ./src/forBrowser.js